module.exports = __webpack_public_path__ + "img/loading-bar.bac4c117.gif";